<div class="gallery" [ngClass]="{ '!flex-row-reverse': isColumnListMode() }">
  <!-- media view -->
  <div class="media-preview">
    @if (selectedPreview && selectedPreview?.type?.includes('video')) {
      <div class="{{ previewWidthClass() }} {{ previewHeightClass() }}">
        <pwj-simple-video-box
          class="media-preview__video"
          playBtnText=""
          [videoPreviewSrc]="selectedPreview?.url | imageSource"
          playBtnSize="small"></pwj-simple-video-box>
      </div>
    } @else {
      <img
        class="media-preview__image {{ previewWidthClass() }} {{
          previewHeightClass()
        }}"
        [ngSrc]="
          (useOriginalUrl()
            ? selectedPreview?.url
            : selectedPreview?.cropped_url?.toLowerCase() ||
              selectedPreview?.url
          ) | imageSource
        "
        [pwjMediaImageFallback]="selectedPreview"
        [pwjMediaImageFallbackFrom]="
          useOriginalUrl() ? 'url' : 'cropped_url'
        "
        [width]="previewWidth()"
        [height]="previewHeight()"
        [priority]="previewPriority()"
        [alt]="(previewAlt() | translateData) || ''"
        [ngClass]="{
          ' cursor-zoom-in': (mediaData()?.length || 0) > 0,
        }"
        (click)="(mediaData()?.length || 0) > 0 && openGalleryDialog()" />
    }
  </div>

  <ul class="media-list" [ngClass]="{ 'flex-col': isColumnListMode() }">
    <!-- media list -->
    @if (mediaData() && (mediaData()?.length || 0) > 0) {
      @for (media of mediaData()?.slice(0, mediaListCount()); track media) {
        <li class="media-list__item" (click)="onSelectPreview(media)">
          <!-- image -->
          @if (media.type?.includes('image')) {
            <div>
              <img
                class="media-list__img  {{ listImgWidthClass() }} {{
                  listImgHeightClass()
                }}"
                [ngSrc]="
                  (useOriginalUrl()
                    ? media?.url
                    : media?.cropped_url?.toLowerCase() || media?.url
                  ) | imageSource
                "
                [pwjMediaImageFallback]="media"
                [pwjMediaImageFallbackFrom]="
                  useOriginalUrl() ? 'url' : 'cropped_url'
                "
                alt="stone"
                [width]="listImgWidth()"
                [height]="listImgHeight()" />
            </div>
          }
          <!-- video -->
          @if (media.type?.includes('video')) {
            <div>
              <pwj-simple-video-box
                class="media-list__img  {{ listImgWidthClass() }} {{
                  listImgHeightClass()
                }}"
                playBtnText=""
                [disableBtn]="true"
                [videoPreviewSrc]="media?.url | imageSource"
                playBtnSize="small"></pwj-simple-video-box>
            </div>
          }
        </li>
      }

      <!-- other media button -->
      @if ((mediaData()?.length || 0) > mediaListCount() - 1) {
        <li
          class="media-list__others {{ listImgWidthClass() }} {{
            listImgHeightClass()
          }}"
          (click)="openGalleryDialog()">
          <!-- preview -->
          @if (mediaData()?.[mediaListCount()]?.type?.includes('image')) {
            <div>
              <img
                class="others-bg-image {{ listImgWidthClass() }} {{
                  listImgHeightClass()
                }}"
                [ngSrc]="
                  (useOriginalUrl()
                    ? mediaData()?.[mediaListCount()]?.url
                    : mediaData()?.[
                        mediaListCount()
                      ]?.cropped_url?.toLowerCase() ||
                      mediaData()?.[mediaListCount()]?.url
                  ) | imageSource
                "
                [pwjMediaImageFallback]="mediaData()?.[mediaListCount()]!"
                [pwjMediaImageFallbackFrom]="
                  useOriginalUrl() ? 'url' : 'cropped_url'
                "
                alt="stone"
                [width]="listImgWidth()"
                [height]="listImgHeight()" />
            </div>
          }
          <!-- other media dots -->
          <div class="others-circles">
            <div class="others-circles__item"></div>
            <div class="others-circles__item"></div>
            <div class="others-circles__item"></div>
          </div>
        </li>
      }
    }
  </ul>
</div>
